import { http } from "./client";
import type { PageParams } from "@/types/api";
import type { EmployeeRequest, EmployeeRequestAttachment, EmployeeRequestStatus, EmployeeRequestType } from "@/types/domain";

export interface EmployeeRequestFilters extends PageParams {
  status?: EmployeeRequestStatus | "";
  type?: EmployeeRequestType | "";
  employee_id?: string;
}

export interface CreateEmployeeRequestInput {
  type: EmployeeRequestType;
  title: string;
  description?: string;
  requested_value?: Record<string, unknown>;
}

export const employeeRequestsApi = {
  list: (filters: EmployeeRequestFilters = {}) => http.getPage<EmployeeRequest>("/employee-requests", filters),
  get: (id: string) => http.get<EmployeeRequest>(`/employee-requests/${id}`),
  create: (input: CreateEmployeeRequestInput) => http.post<EmployeeRequest>("/employee-requests", input),
  cancel: (id: string) => http.post<void>(`/employee-requests/${id}/cancel`, {}),

  decide: (id: string, approve: boolean, comment?: string, linkedAssetId?: string) =>
    http.post<EmployeeRequest>(`/employee-requests/${id}/decide`, { approve, comment, linked_asset_id: linkedAssetId }),
  complete: (id: string) => http.post<EmployeeRequest>(`/employee-requests/${id}/complete`, {}),

  comment: (id: string, message: string) => http.post<void>(`/employee-requests/${id}/comments`, { message }),

  attach: (id: string, file: File) => {
    const form = new FormData();
    form.set("file", file);
    return http.post<EmployeeRequestAttachment>(`/employee-requests/${id}/attachments`, form);
  },
  attachmentUrl: (id: string, attachmentId: string) => `/employee-requests/${id}/attachments/${attachmentId}`,
  downloadAttachment: (id: string, attachmentId: string) => http.download(`/employee-requests/${id}/attachments/${attachmentId}`),
};
